import React, { useEffect, useState } from "react";
import MantineFlex from "../mantine/flex";
import { VerticalMenuItem } from "./SideMenuItem";
import logoMobile from "../../assets/images/logoMobile.png";
import MantineImage from "../mantine/image";
import { sideBarBgImage, themeColors, verticalMenus, verticalMenusUsers } from "../../helpers/constant";
import { useNavigate, useParams } from 'react-router-dom'; 
import VerticalTop from "./Verticaltop";
import { Logo, useCurrentUrl, useCustomMediaQuery } from "../../helpers/common";
import { useStateContext } from "../../Contexts/ContextProvider";
import { LocalGetUser } from "../../helpers/storagehelper";

export function VerticalMenu(props: any) {
    const { children } = props;
    const { currentPrimaryColor, currentBgImage, opensideBar } = useStateContext(); // use context 
    const { isSmallScreenTab, isSmallScreen, isLargeScreen, isMediumScreen, isSmallScreenTablet } = useCustomMediaQuery();
    const navigate = useNavigate();

    const [open, setOpen] = useState<any>(false);
    const [mobileopen, setMobileopen] = useState<any>(false);
    const [iconRole, SetIconRole] = useState<any>(null)
    const [activeSubMenu, setActiveSubMenu] = useState<any>(null);
    const [hover, setHover] = useState(false);
    const currentUrl = useCurrentUrl();
    const height = window?.innerHeight;
    const currentBgimageFilter = sideBarBgImage?.filter((el: any) => el?.name == currentBgImage)[0];
    const handleColorfilterImage = themeColors?.filter((el: any) => el.color == currentPrimaryColor)[0]; //image theme bse image color change

    useEffect(() => {
        const user = LocalGetUser();
        if (user) {
            const role = user?.userRoleName;
            SetIconRole(role || '');
        }
    }, [LocalGetUser()])

    useEffect(() => {
        if (opensideBar == 'icon') setOpen(true);
        else if (isSmallScreenTab) setOpen(true);
        else if (isSmallScreenTablet) setMobileopen(true);
        else setOpen(false); setMobileopen(false);
    }, [opensideBar, isSmallScreenTab]) // side bar icon default value show using context

    const handleNavigationRoute = (routes: any, id: any) => {
        if (routes == "/logout") {
            localStorage.removeItem("authUser");
            localStorage.removeItem("authUsers");
            localStorage.removeItem("token");
            localStorage.removeItem("userid");
            navigate("/login");
        } else {
            navigate(`${routes}`);
        }
    };
    const toggleSubMenu = (index: any) => {
        setActiveSubMenu(activeSubMenu === index ? null : index);
    };
    const onHover = (id: any) => {
        setHover(id);
    };
    const onLeave = (id: any) => {
        setHover(id);
    };

    return (
        <div>
            
            <style>{`
                    .dynamic-div {
                        background-size: cover;
                        background-position: center;
                        background-image: url(${currentBgimageFilter?.src});
                    }
                    .dynamic-div > * {
                        z-index: 100;
                    }
                    .dynamic-div::before{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        content: "";
                        background-color: ${currentPrimaryColor};
                        opacity: ${currentBgimageFilter != undefined && '0.8'};
                        width: 100%;
                    }
                `}</style>
            <MantineFlex>
                <div
                    className={`w-full ${!open ? 'max-w-[250px]' : 'max-w-[78px]'} bg-dark-purple duration-300 z-[99] ${mobileopen ? `${isSmallScreenTablet && 'z-[99]'}` : `${isSmallScreenTablet && '!hidden'}`}`}
                >
                    <div className={`h-[${height}] min-h-dvh border-r-2 bg-current-primary-color pt-8 sticky top-0 dynamic-div`}>
                        {/* <div className="fixed"> */}
                        <MantineFlex justify="center" >
                            <div className={`bg-white z-[99] rounded-full`}>
                                <MantineImage
                                    src={Logo}
                                    className={`rounded-circle p-2 rounded-md`}
                                    height="50"
                                    alt={""}
                                    width={!open && "50"}
                                    style={{ filter: handleColorfilterImage?.filter }}
                                />
                            </div>
                        </MantineFlex>
                        <VerticalMenuItem
                            iconRole={iconRole}
                            open={open}
                            setOpen={setOpen}
                            verticalMenus={verticalMenus}
                            handleNavigationRoute={handleNavigationRoute}
                            currentUrl={currentUrl}
                            verticalMenusUsers={verticalMenusUsers}
                            toggleSubMenu={toggleSubMenu}
                            activeSubMenu={activeSubMenu}
                            onHover={onHover}
                            onLeave={onLeave}
                            hover={hover}
                            currentBgImage={currentBgImage}
                        />
                    </div>
                </div>
                <div className="w-full">
                    <VerticalTop open={open} setOpen={setOpen} currentPrimaryColor={currentPrimaryColor} isSmallScreenTab={isSmallScreenTab} isSmallScreen={isSmallScreen} isLargeScreen={isLargeScreen} setMobileopen={setMobileopen} mobileopen={mobileopen} isMediumScreen={isMediumScreen} isSmallScreenTablet={isSmallScreenTablet} logoMobile={logoMobile} handleColorfilterImage={handleColorfilterImage} />
                    <div className={`px-8`}>
                        <div className={`mt-24`}>{children}</div>
                    </div>
                </div>
            </MantineFlex>
        </div>
    );
}
